import React from 'react'
import ProgressUI from '../../widgets/output/ProgressUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import IconButtonUI from '../../widgets/action/IconButtonUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import TransactionListUI from '../../components/finapp/bankAccount/TransactionListUI'
import TransactionHeaderUI from '../../components/finapp/bankAccount/TransactionHeaderUI'
import TxnDownloadModalSF from '../../components/finapp/bankAccount/TxnDownloadModalSF'
// import './TransactionList2Page.css'

const TransactionListPageUI = ({ context, errorList, txnList, filteredTxnList,
  searchFilter, onRefreshClick, onSearchFilterChange, bankAccountList,
  onCopyToClipboard, copyToClipboardText,
  hasMore, onMoreTransactions, gettingMore,
  downloadMode, onDownloadClick, onDownloadCancel, bankAccountNumber
}) =>
  <PrivatePageSF context={context} className='pg_txns' backLink='/home'
    headerText='Transactions' centered={!txnList && !errorList}>
    {
      !txnList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      txnList &&
      <PageTitleUI context={context} goBack={true} backLink='/home' titleText='Transactions' />
    }
    {
      bankAccountList && txnList &&
      <TransactionHeaderUI
        context={context}
        bankAccountList={bankAccountList}
        onRefreshClick={onRefreshClick}
        downloadMode={downloadMode}
        onDownloadClick={onDownloadClick}
        onDownloadCancel={onDownloadCancel}
        searchFilter={searchFilter}
        onSearchFilterChange={onSearchFilterChange}
      />
    }
    {
      txnList && txnList.length === 0 &&
      <EmptyListUI
        context={context}
        createDisabledMessageLabel='No transactions'
      />
    }
    {
      txnList && filteredTxnList && txnList.length !== 0 &&
      <TransactionListUI
        context={context}
        txnList={filteredTxnList}
        hasMore={hasMore}
        onMoreTransactions={onMoreTransactions}
        gettingMore={gettingMore}
        bankAccountNumber={bankAccountNumber}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
        />
    }

    <TxnDownloadModalSF context={context} downloadMode={downloadMode}
      onCancelClick={onDownloadCancel}
      bankAccountNumber={bankAccountNumber}
    />
  </PrivatePageSF>

export default TransactionListPageUI
